const setCompanyEmailInputPatternForAllCompanyEmailInputs = require("./setCompanyEmailInputPatternForAllCompanyEmailInputs");

/**
 * @return {void}
 */
module.exports = function initCompanyEmailInputs() {
    setCompanyEmailInputPatternForAllCompanyEmailInputs();
}